import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { HoldDetailsType } from '../../../types';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../utils/bills-utils';
import { ReleasableHoldReasons } from './bill-management-types';

export const HoldTypeCell = ({
  holdType,
  note,
}: Partial<HoldDetailsType>): JSX.Element => (
  <HHStack>
    {!holdType ? '--' : capitalizeFirstLetterAndSpaceSnakeString(holdType)}
    {holdType === ReleasableHoldReasons.MANUAL_HOLD ? (
      <HHTypography color="text.primary" hhVariant="input-label">
        {note}
      </HHTypography>
    ) : null}
  </HHStack>
);
